import type { ID } from 'src/lib/collection';

export const VISUAL_LANGUAGE_ASSET_FIELD = {
  imageStyles: 'imageStyles',
} as const;
export type VisualLanguageAssetField =
  (typeof VISUAL_LANGUAGE_ASSET_FIELD)[keyof typeof VISUAL_LANGUAGE_ASSET_FIELD];

export const assignVisualLanguageIdsToAsset = (asset: object, visualLanguageId: ID) => ({
  ...asset,
  visualLanguageId,
});

export const assignVisualLanguageIdsToAssets = (assets: object[], visualLanguageId: ID) =>
  assets.map((asset) => assignVisualLanguageIdsToAsset(asset, visualLanguageId));
